export { ProfessionalPartnershipsForm } from './ProfessionalPartnershipsForm'
